import React from 'react';
import { ProductCard } from './productCard';
import type { ProductItemProps } from './productItemTypes';

export const ProductItem = ({ hit, components }: ProductItemProps) => <ProductCard hit={hit} components={components} />;
